import {ErrorMessage, Field, Form, FormikProps} from 'formik'
import {withFormik} from 'formik'
import * as React from 'react'
import styled from 'styled-components'
import * as Yup from 'yup'
import {Alert} from '../../atoms/Alert'
import {Button} from '../../atoms/Button'
import {FieldError} from '../../atoms/FieldError'
import {Link} from '../../atoms/Link'
import {FieldInput} from '../../molecules/FieldInput'
import {media} from '../../utils/media'
import {ApolloError} from 'apollo-client'

export interface IFormValues {
    password: string
}

export interface IViewProps {
    is: null | 'loading' | 'error' | 'success'
    error: null | ApolloError
    doResetPassword: (values: IFormValues) => void
}

const ResetPasswordViewInner = ({is, error, touched}: FormikProps<IFormValues> & IViewProps) => (
    <Form>
        <Field name="password" type="password" placeholder="Password" style={{marginTop: 20}} component={FieldInput}/>
        <ErrorMessage name="password" component={FieldError}/>
        <Field name="passwordConfirm" placeholder="Confirm Password"
               type="password" style={{marginTop: 20}} component={FieldInput}/>
        <ErrorMessage name="passwordConfirm" component={FieldError}/>
        {is === 'error' && <Alert>{error.graphQLErrors[0].message}</Alert>}
        <div style={{marginTop: 20}}>
            <Button disabled={is === 'loading'} type="submit">
                SEND
            </Button>
        </div>
        <Link to="/login" style={{marginTop: 50}}>Back to Login</Link>
    </Form>
)

const validationSchema = Yup.object().shape({
    password: Yup.string().min(8, 'Too Short!').max(50, 'Too Long!').required('Required'),
    passwordConfirm: Yup.string()
        .oneOf([Yup.ref('password')], 'Passwords must match')
        .required('Required'),
})

export const ResetPasswordView = withFormik<IViewProps, IFormValues>({
    handleSubmit: async (values, {props, setErrors}) => {
        await props.doResetPassword(values)
    },
    validationSchema,
    mapPropsToValues: () => ({password: '', passwordConfirm: ''}),
})(ResetPasswordViewInner)



// WEBPACK FOOTER //
// ./src/organisms/ResetPasswordForm/ResetPasswordView.tsx